module.exports = __webpack_public_path__ + "static/flags/MX-2518c1e611d1fd526198daadd858baf0.gif";